var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"batch_container"},[_c('div',[_c('a-checkbox',{attrs:{"checked":_vm.isCheckAll},on:{"change":_vm.checkAll}},[_vm._v("全选")]),_vm._v(" "),_c('a-space',{staticClass:"ml24",attrs:{"size":10}},[_vm._t("default")],2)],1),_vm._v(" "),_vm._t("right")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f32073c8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/focus/components/BatchCheck.vue
// module id = null
// module chunks = 